import React from 'react';
import fileService from '../../../services/fileService';
import windowService from '../../../services/windowService';
import { CourseStep } from '../models/course';
import { ActionButton } from './ActionButton';

type ContentActionButtonProps = {
  step: CourseStep;
  onPreviewContent?: (content: { name: string; id: string }) => void;
};

export const ContentActionButton = ({ step, onPreviewContent }: ContentActionButtonProps) => {
  const handleDownload = () => {
    fileService.getMetaData(step.assetUrl).then(result => {
      const response = result as { fileMetaData: { _id: { id: string }; fileName: string } };
      windowService.openUrl(fileService.urlOpenFile(response.fileMetaData._id.id, response.fileMetaData.fileName));
    });
  };

  if ((step._type === 'DocumentViewer' || step._type === 'Download') && step.assetUrl) {
    return (
      <ActionButton onClick={handleDownload} aria-label="Download content">
        <i className="fas fa-download" />
        Download
      </ActionButton>
    );
  }

  if ((step._type === 'Audio' || step._type === 'Video') && onPreviewContent) {
    return (
      <ActionButton
        onClick={() => onPreviewContent({ name: step.taskName || '', id: step.videoId || '' })}
        aria-label="Preview content"
      >
        <i className="fas fa-play" />
        Preview
      </ActionButton>
    );
  }

  return null;
};
